export default {
  install(Vue) {
    // Apply Gtm
    let gmt = new Date();
    gmt.getTimezoneOffset() / 60;
    let hour = String(gmt);
    hour = Number(hour.slice(28, 31))
    let hoursDay = 23 + hour


    Date.prototype.add = function (days) {
      var date = new Date(this.valueOf());
      date.setDate(date.getDate() + days);
      return date;
    }
    Date.prototype.substractDays = function (days) {
      var date = new Date(this.valueOf());
      date.setDate(date.getDate() - days);
      return date;
    }

    Vue.prototype.$dateRange = {

      format: function (date, format) {
        if (!date) return null;
        const [year, month, day] = date.split("-");

        switch (format) {
          case 'DD-MM-YYYY':
            return `${day.padStart(2, '0')}-${month.padStart(2, '0')}-${year}`
          case 'DD/MM/YYYY':
            return `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year}`
          default:
            return date
        }
      },

      formatRange: function (range) {
        var date_start_br = new Date(range.date_start).toLocaleString();
        var date_final_br = new Date(range.date_final).toLocaleString();
        return `${date_start_br} - ${date_final_br}`;
        // Output: 01/04/hoursDay21 00:00:00 - 26/04/hoursDay21 23:59:59
      },

      get: {
        onlyDate: function (val) {
          var dateEvent = new Date(val.replace(" ", "T"))
            .toLocaleDateString()
            .slice(0, -5);
          var today = new Date().toLocaleDateString().slice(0, -5);
          if (dateEvent == today) return "HOJE";
          return dateEvent;
        },
        onlyHour: function (val) {
          if (val.lastIndexOf("Z") != -1) {
            return new Date(`${val.slice(0, -5)}${hour}`)
              .toLocaleTimeString()
              .slice(0, hour);
          }
          return new Date(val.replace(" ", "T")).toLocaleTimeString().slice(0, hour);
        },
        today: function () {
          return {
            date_start: new Date(new Date().setHours(hour, 0, 0)).toISOString().slice(0, -1),
            date_final: new Date(new Date().setHours(hoursDay, 59, 59)).toISOString().slice(0, -1),
          }
        },
        yesterday: function () {
          return {
            date_start: new Date(new Date().setHours(hour, 0, 0)).substractDays(1).toISOString().slice(0, -1),
            date_final: new Date(new Date().setHours(hoursDay, 59, 59)).substractDays(1).toISOString().slice(0, -1),
          }
        },
        currentWeek: function () {
          let curr = new Date
          let week = []

          for (let i = 1; i <= 7; i++) {
            let first = curr.getDate() - curr.getDay() + i
            // Tratamento de data para domingo 
            if (curr.getDay() == 0) {
              first = first - 7
            }
            let day = new Date(curr.setDate(first)).toISOString().slice(0, 10);
            week.push(day)
          }

          const startWeek = new Date(new Date(week[0]).setHours(hour, 0, 0)).add(1).toISOString().slice(0, -1);
          const endWeek = new Date(week[week.length - 1]).toISOString().slice(0, -1);

          return {
            date_start: startWeek,
            date_final: endWeek,
          }
        },

        lastWeek: function () {
          let curr = new Date
          let week = []

          for (let i = 1; i <= 7; i++) {
            let first = curr.getDate() - curr.getDay() + i
            // Tratamento de data para domingo 
            if (curr.getDay() == 0) {
              first = first - 7
            }
            let day = new Date(curr.setDate(first)).toISOString().slice(0, 10);
            week.push(day)
          }

          const startWeek = new Date(new Date(week[0]).setHours(hour, 0, 0)).substractDays(6).toISOString().slice(0, -1);
          const endWeek = new Date(new Date(week[0]).setHours(hoursDay, 59, 59)).toISOString().slice(0, -1);

          return {
            date_start: startWeek,
            date_final: endWeek,
          }
        },


        lastSevenDays: function () {



          return {
            date_start: new Date(new Date().setHours(hour, 0, 0)).substractDays(7).toISOString().slice(0, -1),
            date_final: new Date(new Date().setHours(hoursDay, 59, 59)).toISOString().slice(0, -1),
          }
        },

        currentMonth: function () {
          const date = new Date();
          const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
          return {
            date_start: new Date(new Date(firstDay).setHours(hour, 0, 0)).toISOString().slice(0, -1),
            date_final: new Date(new Date().setHours(hoursDay, 59, 59)).toISOString().slice(0, -1),
          }
        },

        halfMonth: function () {
          return {
            date_start: new Date(new Date().setHours(hour, 0, 0)).substractDays(15).toISOString().slice(0, -1),
            date_final: new Date(new Date().setHours(hoursDay, 59, 59)).toISOString().slice(0, -1),
          }
        },

        lastMonth: function () {
          var date = new Date();
          var firstDay = new Date(date.getFullYear(), date.getMonth() - 1, 1);
          var lastDay = new Date(date.getFullYear(), date.getMonth(), 0);

          return {
            date_start: new Date(new Date(firstDay).setHours(hour, 0, 0)).toISOString().slice(0, -1),
            date_final: new Date(new Date(lastDay).setHours(hoursDay, 59, 59)).toISOString().slice(0, -1),
          }
        },

        localeDateTime: function () {
          let date = (new Date()).toLocaleDateString();
          let time = (new Date()).toLocaleTimeString();
          return `${date} ${time}`;
        }
      }
    }
  }
}